export default __webpack_public_path__ + "assets/icons/chevronUp.db93d6ed.svg";